import { useMemo } from 'react';
import { combineValidators } from './validation';
const EMAIL_REGEX = /\S+@\S+\.\S+/u;
const createMinLengthValidator = (minLength, tooShortMessage) => {
    return (value) => ((value === null || value === void 0 ? void 0 : value.length) < minLength ? tooShortMessage : false);
};
const createMaxLengthValidator = (maxLength, tooLongMessage) => {
    return (value) => ((value === null || value === void 0 ? void 0 : value.length) > maxLength ? tooLongMessage : false);
};
const createEmailValidator = (emailFormatErrorMessage) => {
    return (value) => (value && !EMAIL_REGEX.test(value) ? emailFormatErrorMessage : false);
};
export const useValidator = (settings) => {
    const { emailFormatErrorMessage, maxLength, tooLongMessage, minLength, tooShortMessage, validate } = settings;
    return useMemo(() => {
        const validators = [
            validate,
            maxLength && createMaxLengthValidator(maxLength, tooLongMessage),
            minLength && createMinLengthValidator(minLength, tooShortMessage),
            emailFormatErrorMessage && createEmailValidator(emailFormatErrorMessage),
        ].filter(Boolean);
        return combineValidators(...validators);
    }, [emailFormatErrorMessage, validate, tooLongMessage, maxLength, minLength, tooShortMessage]);
};
//# sourceMappingURL=useValidator.js.map